'use client';

import { datadogRum } from '@datadog/browser-rum';
import { type PropsWithChildren, useEffect } from 'react';

type TrackerProps = {
  serverSideExperimentDecision: string;
  staticExperimentName?: string;
};

function StaticExperimentTracker({
  serverSideExperimentDecision,
  staticExperimentName,
}: TrackerProps) {
  useEffect(() => {
    if (staticExperimentName) {
      datadogRum.addFeatureFlagEvaluation(
        // The hyphen is not allowed according to DD documentation
        //  https://docs.datadoghq.com/real_user_monitoring/guide/setup-feature-flag-data-collection/?tab=browser#feature-flag-naming
        staticExperimentName?.replace('-', '_'),
        serverSideExperimentDecision,
      );
      datadogRum.addAction('Static ABSmartly Bucketing', {
        staticExperimentName,
      });
    }
  }, [staticExperimentName]);

  return null;
}

type Props = PropsWithChildren<{
  serverSideExperimentDecision: string;
  staticExperimentName?: string;
}>;

export function LogStaticExperiments({
  children,
  serverSideExperimentDecision,
  staticExperimentName,
}: Props) {
  return (
    <>
      <StaticExperimentTracker
        serverSideExperimentDecision={serverSideExperimentDecision}
        staticExperimentName={staticExperimentName}
      />
      {children}
    </>
  );
}
